import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

export function asyncConnect(configs = []) {
  return function wrap(WrappedComponent) {
    class AsyncConnectWrapper extends Component {
      render() {
        return <WrappedComponent {...this.props} />;
      }
    }

    AsyncConnectWrapper.loadData = function loadData(ctx) {
      const tasks = (configs || []).map((cfg) => {
        if (!cfg || typeof cfg.promise !== 'function') return null;
        return cfg.promise(ctx);
      }).filter(Boolean);

      return Promise.all(tasks);
    };

    hoistNonReactStatics(AsyncConnectWrapper, WrappedComponent);
    return AsyncConnectWrapper;
  };
}

export function reducer(state = {}) {
  return state;
}

export class ReduxAsyncConnect extends Component {
  render() {
    return null;
  }
}

export function loadOnServer() {
  return Promise.resolve();
}
